<script setup lang="ts">import { ref as _ref } from 'vue';

const props = defineProps<{
  code: string;
}>();

let message = _ref("");
let heading = _ref("");

switch (parseInt(props.code, 10)) {
  case 404:
    heading.value = "Sorry about this";
    message.value = `It looks like a developer doesn't know how to type an address in.
                              Let us know about it and we'll try again`;
    break;
  case 500:
    heading.value = "Yikes, that wasn't expected";
    message.value = `An error has happened that we didn't anticipate.
                              If you continue to see this message, please inform a member of IT support`;
    break;
  case 204:
    heading.value = "Whoops, we've misplaced that";
    message.value = `If you just clicked a bookmark, then it is outdated.
                              Try searching for your case/file instead.
                              If you just searched for a case, then apologies, but we can't find that case either.
                              Please try searching again.`;
    break;
  case 300:
    heading.value = "Incomplete url";
    message.value = `Sorry, there isn't enough information in the the URL for us to route your request.
                              If you followed a bookmark to get to this url, then that bookmark is outdated`;
    break;
  default:
    heading.value = "Yikes, that wasn't expected";
    message.value = `An error has happened that we didn't anticipate.
                              If you continue to see this message, please inform a member of IT support`;
    break;
}
</script>
<template>
  <div class="tw-mx-auto tw-mt-3 tw-w-2/3 tw-shadow">
    <div class="tw-bg-red-700 tw-p-2 tw-text-white">{{ heading }}</div>
    <div class="tw-p-2">
      <p>{{ message }}</p>
    </div>
  </div>
</template>
